import loading from "../assets/images/loading.svg";

export const PageLoading = () => (
  <div
    className="spinner"
    style={{
      display: "grid",
      minHeight: "100vh",
      placeContent: "center",
    }}
  >
    <img style={{ scale: "1.5" }} src={loading} alt="Loading" />
  </div>
);
